
import axios from 'axios';
import qs from 'qs';
import systemSelectsPop from '@/components/app/common/systemSelectsPop/index.vue';

const module = {
    name: 'login',
    components:{
        systemSelectsPop
    },
    data() {
        return {
            user: {
                username: "",
                password: ""
            },
            rules: {
                // usn和prop对应
                username: [
                    // blur表示鼠标失焦时触发
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur'}
                ]
            },
            // 防抖函数
            debounceTimeout: null,
            // 忘记密码弹框
            dialogVisible:false,
        }
    },
    methods: {
        // 忘记密码提示
        forgetPwd(){
           this.dialogVisible = true
        },
        loginHandler() {
            // 防抖处理
            this.debounce(() => {
                this.$refs['loginForm'].validate(valid => {
                    if (valid) {
                        // 请求
                        this.loginRequeast().then(async (data) => {
                            const _data = data.data.data;
                            localStorage.setItem("ms_username", this.user.username);
                            this.$store.commit('bizTypes', _data.platforms);
                            axios.defaults.headers['cloud-ops-token'] = _data.token;
                            localStorage.setItem("token", _data.token);
                            // 符合该平台的权限list
                            const platformsList = _data.platforms.filter(item => [0, 1].includes(item));
                            switch (platformsList.length) { 
                                case 2: {
                                    // 处理同时拥有两个权限的情况
                                    // 之前是不是选择过一个进去了
                                    if (["0", "1"].includes(localStorage.getItem('bizType'))) {
                                        axios.defaults.headers['cloud-ops-platform'] = localStorage.getItem('bizType');
                                        this.$router.push({
                                            path: '/index'
                                        });
                                    } else {
                                        this.$refs.systemSelectsPop.dialogSystemPopVisible = true;
                                    }
                                    break;
                                }
                                case 1: {
                                    // 处理只有一个权限的情况
                                    localStorage.setItem("bizType", platformsList[0]);
                                    axios.defaults.headers['cloud-ops-platform'] = platformsList[0];
                                    this.$router.push({
                                        path: '/index'
                                    });
                                    break;
                                }
                                case 0:
                                default: {
                                    // 处理没有权限的情况
                                    this.$message({
                                        type: 'error',
                                        message: '当前用户没有权限，请联系管理员！',
                                        duration: 2000,
                                        showClose: true
                                    });
                                    break;
                                }
                            }
                        }).catch((err) => {
                            this.$message({
                                type: 'error',
                                message: `${err.msg}`,
                                duration: 2000,
                                showClose: true
                            });
                        });
                    }
                });
            }, 200);
        },
        /**
         * 防抖
         * @param fn
         * @param wait
         * @returns {function(): void}
         */
        debounce(fn, wait) {
            if (this.debounceTimeout !== null) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            this.debounceTimeout = setTimeout(fn, wait);
        },
        // 登录请求
        loginRequeast() {
            const _data = {
                username: this.user.username,
                password: this.user.password
            }
            const _method = window.fdConfig.methodPost;
            const _url = window.fdConfig.isDebug ? window.fdConfig.url.login.loginPort : window.fdConfig.url.login('loginPort');
            return axios({
                method: _method,
                url: _url,
                data: _data
            })
        },
        enterKey(event) {
            const componentName = this.$options.name;
            if (componentName == "login") {
                const code = event.keyCode
                    ? event.keyCode
                    : event.which
                        ? event.which
                        : event.charCode;
                if (code == 13) {
                    this.loginHandler();
                }
            }
        },
        enterKeyupDestroyed() {
            document.removeEventListener("keyup", this.enterKey);
        },
        enterKeyup() {
            document.addEventListener("keyup", this.enterKey);
        }
    },
    mounted() {
        // 绑定enter事件
        this.enterKeyup();
    },
    destroyed() {
        // 销毁enter事件
        this.enterKeyupDestroyed();
    }
}
export default module;
